export default __webpack_public_path__ + "static/media/logo1.9afee613.svg";